import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-list-item-item',
  templateUrl: './check-list-item-item.component.html',
  styleUrls: ['./check-list-item-item.component.css']
})
export class CheckListItemItemComponent implements OnInit {
    checkListItemItemKeyno;

    checkListItemKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.checkListItemItemKeyno = this.stateService.getStateParams()['checklistitemitem_keyno'];
        this.checkListItemKeyno = this.stateService.getStateParams()['checklistitem_keyno'];
    }

    private async loadEdit() {
        if (!!this.checkListItemItemKeyno && !!this.checkListItemKeyno) {
            this.edit = (await this.datatask.Post(562, {
                checklistitemitem_keyno: this.checkListItemItemKeyno,
                checklistitem_keyno: this.checkListItemKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(565, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    checklistitemitem_keyno: string;
    checklistitemitem_name: string;
    checklistitemitem_order: string;
    checklistitem_keyno: string;
    checklistitemitem_code: string;
    isactive: string;
}
